export enum QuestionScoreDisplayLevel {
  QuestionLevel = 'questionLevel',
  QuestionAndSubQuestionLevel = 'questionAndSubQuestionLevel'
}
